module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 103.fb9ca752.png";